import css from "styled-jsx/css";

export const componentStyles = css.global`
  .universe-header-desktop-content {
    &.existing-account-header {
      .header-create-account-button-wrapper {
        padding-left: 6px;
        padding-right: 2px;
      }
    }
  }
`;
